// extracted by mini-css-extract-plugin
export default {"likes":"Likes_likes__-XJr7","likesList":"Likes_likesList__AWtDO","like":"Likes_like__GxJn8"};